export default __webpack_public_path__ + "static/30site-6e6b7aa4273e8bc7101304680a124639.png";